import * as React from 'react';
export default ((context, {
  enabled
}) => React.useMemo(() => {
  if (!enabled) return {};
  return {
    reference: {
      onKeyUp(e) {
        if (e.code === 'Tab') context.onOpenChange(true);
      },
      onBlur() {
        context.onOpenChange(false);
      }
    }
  };
}, [enabled, context]));